'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fad';
var iconName = 'trophy-star';
var width = 576;
var height = 512;
var aliases = ["trophy-alt"];
var unicode = 'f2eb';
var svgPathData = ['M446.1 64c-1 16.9-2.5 32.9-4.3 48h85.3c-7.5 97.9-60.9 150.6-114.6 179.9c-11 6-22 11-32.6 15.2c-24.5 37.8-50.6 57.4-68.6 67.3c7.5-1 17.8-2.7 30-5.4c25.5-5.7 59.8-16.1 94.3-35C505.6 295.7 576 222.5 576 88c0-13.3-10.7-24-24-24H446.1zM264.7 374.5c-18.1-9.9-44.1-29.5-68.6-67.3c-10.6-4.2-21.6-9.2-32.6-15.2C109.8 262.6 56.4 209.9 48.9 112h85.3c-1.8-15.1-3.3-31.1-4.3-48H24C10.7 64 0 74.7 0 88C0 222.5 70.4 295.7 140.5 334.1c34.5 18.9 68.8 29.3 94.3 35c12.2 2.7 22.5 4.4 30 5.4zM295.2 86.5c-2.9-5.9-11.4-5.9-14.3 0l-19.2 38.9c-1.2 2.4-3.4 4-6 4.4L212.7 136c-6.6 1-9.2 9-4.4 13.6l31 30.2c1.9 1.8 2.7 4.5 2.3 7.1l-7.3 42.7c-1.1 6.5 5.7 11.5 11.6 8.4L284.3 218c2.3-1.2 5.1-1.2 7.4 0l38.4 20.2c5.9 3.1 12.7-1.9 11.6-8.4L334.4 187c-.4-2.6 .4-5.2 2.3-7.1l31-30.2c4.7-4.6 2.1-12.7-4.4-13.6l-42.9-6.2c-2.6-.4-4.9-2-6-4.4L295.2 86.5z', 'M235.2 353.4c12.2 10.8 20.8 25.7 20.8 42V400c0 26.5-21.5 48-48 48H192c-17.7 0-32 14.3-32 32s14.3 32 32 32H384c17.7 0 32-14.3 32-32s-14.3-32-32-32H368c-26.5 0-48-21.5-48-48v-4.5c0-16.3 8.6-31.2 20.8-42C383.8 315.3 438.7 231 447 48c1.2-26.5-20.4-48-47-48H176c-26.5 0-48.1 21.6-47 48c8.2 183 63.2 267.2 106.2 305.4zm60-266.9l19.2 38.9c1.2 2.4 3.4 4 6 4.4l42.9 6.2c6.6 1 9.2 9 4.4 13.6l-31 30.2c-1.9 1.8-2.7 4.5-2.3 7.1l7.3 42.7c1.1 6.5-5.7 11.5-11.6 8.4L291.7 218c-2.3-1.2-5.1-1.2-7.4 0l-38.4 20.2c-5.9 3.1-12.7-1.9-11.6-8.4l7.3-42.7c.4-2.6-.4-5.2-2.3-7.1l-31-30.2c-4.7-4.6-2.1-12.7 4.4-13.6l42.9-6.2c2.6-.4 4.9-2 6-4.4l19.2-38.9c2.9-5.9 11.4-5.9 14.3 0z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faTrophyStar = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;